<template>
    <div class="checker-banner">
        <span class="checker-banner__Icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" :class="['icon--' + iconSize]" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm1-14a1 1 0 10-2 0 1 1 0 002 0zm-1 9a1 1 0 001-1v-5a1 1 0 10-2 0v5a1 1 0 001 1z" fill="currentColor"/></svg>
        </span>
        <p>
            <slot></slot>
        </p>
    </div>
</template>

<script>
export default {
    name: "CheckerBanner",
    props: {
        iconSize: {
            type: String,
            default: "m",
            validator: function(value) {
                return ["s", "m", "l"].indexOf(value) !== -1;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.checker-banner {
    display: flex;
    border-radius: 4px;
    border: 1px solid $color-blue-60;
    background: $color-blue-00;
    padding: rem(12);
    gap: rem(8);
}

.checker-banner__Icon {
    color: $color-blue-60;
    display: inline-flex;
    vertical-align: bottom;
    flex: 0 0 auto;
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: auto;
}

.icon {
    &--s {
        width: rem(16);
        height: rem(16);
    }

    &--m {
        width: rem(24);
        width: rem(24);
    }

    &--l {
        width: rem(32);
        height: rem(32);
    }
}
</style>